import {
  Button,
  Container,
  Paper,
  Typography,
  ThemeProvider,
  CssBaseline,
} from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { globalStyles } from "../../styles/globalStyleTheming";

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <ThemeProvider theme={globalStyles}>
      <CssBaseline />
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            maxWidth: 500,
            width: "100%",
          }}
        >
          <Typography
            data-testid="login-title"
            variant="h4"
            component="h1"
            sx={{ mb: 3, textAlign: "center" }}
          >
            Earthly Admin Panel
          </Typography>

          <Typography variant="body1" sx={{ mb: 4, textAlign: "center" }}>
            Please log in to access the admin panel
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => loginWithRedirect()}
            sx={{
              minWidth: 200,
              py: 1.5,
              fontSize: "1.1rem",
            }}
          >
            Log In
          </Button>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default LoginPage;
